import _default from './TextArea';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/TextArea/index.js
// module id = 288
// module chunks = 0